export default "__VITE_ASSET__82d3d13d__"